import Request from '@hotmart/request'
import { USER_REQUEST_IDENTIFIERS } from './user.constants'

Request.register(`${process.env.API_MARKETPLACE}/userprofile/rest/v1`, {
  get: {
    [USER_REQUEST_IDENTIFIERS.PROFILE]: '/user?onlySupportedLocales=true',
    [USER_REQUEST_IDENTIFIERS.COLLABORATOR]: '/collaboratorsArea/accept?rows=100',
    [USER_REQUEST_IDENTIFIERS.COLLABORATOR_PENDING_INVITES]: '/collaboratorsArea/pendingInvites'
  }
})

Request.register(`${process.env.API_SALES_PROFILER}/rest/v1`, {
  get: {
    [USER_REQUEST_IDENTIFIERS.CLUSTER]: '/cluster'
  }
})

Request.register(`${process.env.API_ACCOUNT}/address/rest/v1`, {
  get: {
    [USER_REQUEST_IDENTIFIERS.USER_FROM]: '/isSameCountry'
  }
})

Request.register(`${process.env.API_BUSINESS_WORKSPACE}/v1`, {
  get: {
    'bw.user.type': '/user/type'
  }
})
